export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-wireframes-ec542f6f6e2c08d412bb55d1b949c26c.png";